<div [@fadeInUp] *ngIf="topic" [class]="topicClass" [innerHtml]="topic?.body | safeHtml"></div>
